import React from "react";
import Link from "next/link";
export const Button = ({
    children,
    bgColor = null,
    textColor = null,
    link = "#",
    className,
}) => {
    return (
        <Link
            href={link}
            className={`${bgColor ? bgColor : "bg-primary"} 
            ${
                textColor ? textColor : "text-white"
            } py-2.5 px-8 lg:px-12 rounded-[20px] inline-block font-medium text-[14px] md:text-[16px] xl:text-[18px]  ${className}`}
        >
            {children}
        </Link>
    );
};
